import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { ErrorBoundaryProvider } from "../error-boundary/error-boundary.provider.js";
function createServicesProvider(initialContext, errorLog) {
  const ServicesContext = createContext(initialContext);
  const ServicesProvider = ({ children }) => {
    return /* @__PURE__ */ jsx(ServicesContext.Provider, { value: initialContext, children: /* @__PURE__ */ jsx(ErrorBoundaryProvider, { onLog: errorLog, children }) });
  };
  const useServices = () => {
    return useContext(ServicesContext);
  };
  return {
    ServicesProvider,
    useServices
  };
}
export {
  createServicesProvider
};
//# sourceMappingURL=services.provider.js.map
